/**
 * The auth calls every product's client makes the same way.
 *
 * The session and client-id endpoints are one contract across products —
 * the server resolves the product by Host, and the envelope is the same —
 * so the fetches live here once. What differs per product is the shape of
 * its user, which is why `genFetchSessionUser` is generic over it, and the
 * sign-in exchange, which each product writes for its own gates.
 *
 * Contract:
 *   GET  /api/auth/session          -> { data: { user: User | null } }
 *   GET  /api/auth/google_client_id -> { data: { client_id: string } }
 *
 * When the backend is unavailable both calls degrade to "logged out" or
 * "unavailable" rather than throwing, so the UI stays usable.
 */// Same-origin requests; the session cookie must ride along.
export const SAME_ORIGIN={credentials:"same-origin"};/**
 * Fetch the current session's user, or null when logged out. Never throws
 * for the "not signed in" case — a missing or error response is treated as
 * logged out so the UI stays usable.
 */export async function genFetchSessionUser(){try{const response=await fetch("/api/auth/session",SAME_ORIGIN);if(!response.ok){return null;}// response.json() is untyped; assert the documented envelope shape.
const body=await response.json();const user=body&&body.data?body.data.user:null;return user==null?null:user;}catch(error){// Network error or no backend: treat as logged out.
console.warn("genFetchSessionUser failed; treating as logged out.",error);return null;}}/**
 * Fetch the product's public Google OAuth client id, used to initialize
 * Google Identity Services. Returns null if it cannot be fetched (e.g. the
 * backend isn't configured), so the caller can degrade gracefully.
 */export async function genFetchGoogleClientId(){try{const response=await fetch("/api/auth/google_client_id",SAME_ORIGIN);if(!response.ok){return null;}// response.json() is untyped; assert the documented envelope shape.
const body=await response.json();const clientId=body&&body.data?body.data.client_id:null;return clientId!=null&&clientId!==""?clientId:null;}catch(error){console.warn("genFetchGoogleClientId failed.",error);return null;}}